import { Icon } from "@elaniintc/goes-design-system/ui";

export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center py-8 px-4">
    <div className="size-12 rounded-full bg-neutral-object-accent-silent flex items-center justify-center mb-3">
      <Icon type="far" name="bell-slash" className="text-body-quiet text-lg" />
    </div>
    <p className="text-body-loud font-semibold text-size-body-sm">
      Sin notificaciones
    </p>
    <p className="text-body-quiet text-size-body-xs text-center mt-1">
      No tienes notificaciones pendientes en este momento
    </p>
  </div>
);
